import { Link } from 'react-router-dom';

import styled from 'styled-components';
import getSubjectsType from '../../../utils/get-Subject-Types';

interface propTypes {
  $subject: string;
  $color: number;
  $textcolor: number;
  $hovercolor: number;
  $active: boolean;
}

export const ClassesBox = styled.div`
  max-height: fit-content;
  overflow: overlay;
  top: 0;

  &::-webkit-scrollbar {
    display: block;
    width: 8px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background-color: #00000000;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: #00000000;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #00000040;
    border: 1px solid #ffffff40;
    border-radius: 24px;
  }
`;

export const Button = styled(Link)<propTypes>`
  text-decoration: none;
  border-bottom: 1px solid #A7A7A7;
  padding: 25px 16px;
  width: 100%;
  max-height: 80px;
  display: flex;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  background-color: ${({ $active }) => (
      !$active ? '#FFFFFF' : '#A648FF')};;

  color: ${({ $active }) => (
      !$active ? '#242268' : '#FFFFFF')};
  font-weight: 400;
  font-family: "Museo";

  &:hover { 
    background-color: #6EFEE4;
    color: #333;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
    border-bottom: none;
  }
`;
